// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body{background:#eee}body #modal-membership-upgraded .modal-dialog{max-width:446px}body #modal-membership-upgraded img{max-height:250px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
